<template>
    <div class="mid-autumn-body" id="midAutumn">
        <div class="latern" id="latern">
            <!-- <div class="kongming-latern">
                <div class="latern-left"></div>
                <div class="latern-right"></div>
                <div class="latern-bottom"></div>
            </div>
            <div class="kongming-latern">
                <div class="latern-left"></div>
                <div class="latern-right"></div>
                <div class="latern-bottom"></div>
            </div>
            <div class="kongming-latern">
                <div class="latern-left"></div>
                <div class="latern-right"></div>
                <div class="latern-bottom"></div>
            </div>
            <div class="kongming-latern-litle">
                <div class="latern-left"></div>
                <div class="latern-right"></div>
                <div class="latern-bottom"></div>
            </div> -->

            <div :class="getRandomLaternClass()" v-for="(item, index) in list" :style="{
                    left: item.left,
                    bottom: item.bottom,
                    animationDelay: item.animationDelay
                }">
                <div class="latern-left"></div>
                <div class="latern-right"></div>
                <div class="latern-bottom"></div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {

    },
    data() {
        return {
            list:[],
        };
    },
    mounted() {
        let arr=[]
        for (let i = 0; i < 5; i++) {
            let obj = {
                left: this.numberRandom(100, 0) + 'vw',
                bottom: this.numberRandom(-20, -15) + 'vw',
                animationDelay: this.numberRandom(30, 1) +'s'
            }
            arr.push(obj)
        }
        this.list=arr
    },
    computed: {

    },
    watch: {

    },
    methods: {
        numberRandom(max, min) {
            // console.log('numberRandom')
            var num = (Math.random() * (max - min) + min).toFixed(2)
            return num;
        },
        getRandomNumber() {
            // 生成一个 0 到 3 的随机整数
            var randomNumber = Math.floor(Math.random() * 4);
            // 将随机整数加 1，得到 1 到 4 的随机数
            return randomNumber + 1;
        },
        getRandomLaternClass() {
            // 生成一个 0 到 1 的随机数
            var randomNumber = Math.random();
            // 根据随机数返回不同的字符串
            if (randomNumber < 0.2) {
                return 'kongming-latern';
            } else {
                return 'kongming-latern-litle';
            }
        }
    },
};
</script>
<style lang="less" scoped>
@keyframes FlyOne {
    10% {
        transform: translateX(7vw) translateY(-10vh) rotate(0deg);
    }

    40% {
        transform: translateX(2vw) translateY(-30vh) rotate(5deg);
    }

    70% {
        transform: translateX(10vw) translateY(-70vh) rotate(-5deg);
    }

    100% {
        transform: translateX(3vw) translateY(-120vh) rotate(3deg);
    }
}

@keyframes FlyTwo {
    10% {
        transform: translateX(2vw) translateY(-15vh) rotate(0deg);
    }

    40% {
        transform: translateX(10vw) translateY(-60vh) rotate(5deg);
    }

    70% {
        transform: translateX(3vw) translateY(-90vh) rotate(-5deg);
    }

    100% {
        transform: translateX(12vw) translateY(-100vh) rotate(3deg);
        opacity: 0.1;
    }
}

@keyframes FlyThree {
    10% {
        transform: translateX(5vw) translateY(-20vh) rotate(0deg);
        opacity: 1;
    }

    40% {
        transform: translateX(1vw) translateY(-50vh) rotate(5deg);
        opacity: 0.8;
    }

    70% {
        transform: translateX(7vw) translateY(-80vh) rotate(-5deg);
        opacity: 0.7;
    }

    100% {
        transform: translateX(14vw) translateY(-100vh) rotate(3deg);
        opacity: 0.1;
    }
}

@keyframes FlyFour {
    100% {
        transform: translateY(-100vh);
        opacity: 0.1;
    }
}

@keyframes Wink {
    100% {
        width: 0;
    }
}

.mid-autumn-body {
    position: fixed;
    left: 0;
    /* transform: translate(-50%); */
    width: 100vw;
    height: 100vh;
    overflow: hidden;
}

.kongming-latern,
.kongming-latern-litle {
    position: absolute;
    height: 5.1vw;
    width: 3.5vw;
    bottom: -8vw;
    background: linear-gradient(#92090e, #ea3d2d, #fbf885);
    animation: FlyOne 22s linear infinite;
}

.latern-left {
    border-left: 5vw solid transparent;
    border-right: 1vw solid transparent;
    border-bottom: 0.9vw solid #ea4c35;
    transform: rotate(-90deg);
    position: relative;
    top: 2.5vw;
    left: -3.4vw;
}

.latern-right {
    border-left: 1vw solid transparent;
    border-right: 5vw solid transparent;
    border-bottom: 0.9vw solid #ea4c35;
    transform: rotate(90deg);
    position: relative;
    top: 1.6vw;
    left: 0.9vw;
}

.latern-bottom {
    position: relative;
    top: 3vw;
    width: 3.5vw;
    height: 1.2vw;
    background: radial-gradient(#fff, #fbf885, #ea3d2d);
    border-radius: 2vw;
}

.kongming-latern {
    z-index: 2;
}

.kongming-latern:nth-child(2),
.kongming-latern:nth-child(3) {
    animation: FlyThree 18s linear infinite;
    animation-delay: 6s;
    height: 3.7vw;
    left: 5vw;
    width: 2.5vw;
    bottom: -10vw;
}

.kongming-latern:nth-child(2) {
    bottom: -7vw;
    left: 2vw;
    animation: FlyTwo 15s linear infinite;
    animation-delay: 2s;
}

.kongming-latern:nth-child(2) .latern-left,
.kongming-latern:nth-child(3) .latern-left {
    border-left: 3vw solid transparent;
    top: 1.5vw;
    left: -2.4vw;
}

.kongming-latern:nth-child(2) .latern-right,
.kongming-latern:nth-child(3) .latern-right {
    border-right: 3vw solid transparent;
    top: 0.6vw;
    left: 0.9vw;
}

.kongming-latern:nth-child(2) .latern-bottom,
.kongming-latern:nth-child(3) .latern-bottom {
    top: 1.6vw;
    height: 1vw;
    width: 2.5vw;
}

.kongming-latern-litle {
    height: 2vw;
    left: 5vw;
    width: 1.2vw;
    bottom: 5vw;
    animation: FlyFour 15s linear infinite;
}

.kongming-latern-litle .latern-left {
    border-left: 1.7vw solid transparent;
    border-right: 0.3vw solid transparent;
    border-bottom: 0.5vw solid #ea4c35;
    top: 0.75vw;
    left: -1.2vw;
}

.kongming-latern-litle .latern-right {
    border-left: 0.3vw solid transparent;
    border-right: 1.7vw solid transparent;
    border-bottom: 0.5vw solid #ea4c35;
    top: 0.26vw;
    left: 0.4vw;
}

.kongming-latern-litle .latern-bottom {
    top: 0.6vw;
    width: 1.2vw;
    height: 0.5vw;
}

/* 竖屏媒体查询 */
@media (orientation: portrait) {
    .kongming-latern,
    .kongming-latern-litle {
        height: 5.1vh;
        width: 3.5vh;
    }

    .latern-left {
        border-left: 5vh solid transparent;
        border-right: 1vh solid transparent;
        border-bottom: 0.9vh solid #ea4c35;
        top: 2.5vh;
        left: -3.4vh;
    }

    .latern-right {
        border-left: 1vh solid transparent;
        border-right: 5vh solid transparent;
        border-bottom: 0.9vh solid #ea4c35;
        top: 1.6vh;
        left: 0.9vh;
    }

    .latern-bottom {
        top: 3vh;
        width: 3.5vh;
        height: 1.2vh;
    }

    .kongming-latern:nth-child(2),
    .kongming-latern:nth-child(3) {
        height: 3.7vh;
        width: 2.5vh;
    }

    .kongming-latern:nth-child(2) .latern-left,
    .kongming-latern:nth-child(3) .latern-left {
        border-left: 3vh solid transparent;
        top: 1.5vh;
        left: -2.4vh;
    }

    .kongming-latern:nth-child(2) .latern-right,
    .kongming-latern:nth-child(3) .latern-right {
        border-right: 3vh solid transparent;
        top: 0.6vh;
        left: 0.9vh;
    }

    .kongming-latern:nth-child(2) .latern-bottom,
    .kongming-latern:nth-child(3) .latern-bottom {
        top: 1.6vh;
        height: 1vh;
        width: 2.5vh;
    }

    .kongming-latern-litle {
        height: 2vh;
        width: 1.2vh;
    }

    .kongming-latern-litle .latern-left {
        border-left: 1.7vh solid transparent;
        border-right: 0.3vh solid transparent;
        border-bottom: 0.5vh solid #ea4c35;
        top: 0.75vh;
        left: -1.2vh;
    }

    .kongming-latern-litle .latern-right {
        border-left: 0.3vh solid transparent;
        border-right: 1.7vh solid transparent;
        border-bottom: 0.5vh solid #ea4c35;
        top: 0.26vh;
        left: 0.4vh;
    }

    .kongming-latern-litle .latern-bottom {
        top: 0.6vh;
        width: 1.2vh;
        height: 0.5vh;
    }
}
</style>